module.exports = __webpack_public_path__ + "static/media/img1-3.f20662ad.png";